import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Heading,
} from "@chakra-ui/react";
import DButton from "./DButton";
import { icon } from "../utils/icons";
const DModal = ({ isOpen, onClose, bodyText, clickHandler, modelType }) => {
  const model = {
    delete: {
      header: (
        <div className="text-center">
          <p className="text-6xl text-secondry-color-500">{icon.info}</p>
          <Heading as="h2" size={["lg"]}>
            تحذير
          </Heading>
        </div>
      ),
      body: (
        <>
          <p>{bodyText}</p>
        </>
      ),
      action: (
        <DButton bgColor="danger" className="text-white" onClick={clickHandler}>
          تأكيد الحذف
        </DButton>
      ),
    },
    process: {
      header: (
        <div className="text-center">
          <p className="text-6xl flex justify-center text-secondry-color-500">
            {icon.info}
          </p>
          <Heading as="h2" size={["lg"]}>
            معلومات
          </Heading>
        </div>
      ),
      body: (
        <>
          <p>{bodyText}</p>
        </>
      ),
      action: (
        <DButton bgColor="danger" className="text-white" onClick={clickHandler}>
          تأكيد
        </DButton>
      ),
    },
    popupMessage: {
      header: (
        <div className=" flex items-center justify-center gap-2 ">
          <div>
            <p className="text-4xl text-secondry-color-500">{icon.info}</p>
          </div>
          <div>
            <Heading as="h2" size={["lg"]}>
              معلومات
            </Heading>
          </div>
        </div>
      ),
      body: (
        <>
          <h2 className="text-2xl font-bold text-center "> تم فك التشفير : {bodyText}</h2>
        </>
      ),
      action: "",
    },
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader className="mx-auto">{model[modelType].header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{model[modelType].body}</ModalBody>
        <ModalFooter>
          {model[modelType].action}
          <DButton
            className="text-white"
            colorScheme="blue"
            mr={3}
            onClick={onClose}
          >
            إغلاق
          </DButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DModal;
